module.exports = __webpack_public_path__ + "img/Vector.e8e63ea0.svg";